import { attachSummernote } from "../summernoteHelper";
import { onTurboPageLoad } from "../turboHelper";
import { formSubmitWithSpinner } from "../jobCompletion";

onTurboPageLoad("Messaging/CreateMessage", () => {
    const fromPicker = $('#validity-from') as any;
    const fromPickerValueHolder = $('#validity-from-holder');
    const tillPicker = $('#validity-till') as any;
    const tillPickerValueHolder = $('#validity-till-holder');

    fromPicker.datetimepicker({
        //minDate: moment().add(15, 'minutes'),
    });
    tillPicker.datetimepicker({
        useCurrent: false
    });

    fromPicker.on("change.datetimepicker", e => {
        if (!e.date) return;

        fromPickerValueHolder.val(e.date.toJSON());
        tillPicker.datetimepicker('minDate', e.date);
    });
    tillPicker.on("change.datetimepicker", e => {
        if (!e.date) return;

        tillPickerValueHolder.val(e.date.toJSON());
        fromPicker.datetimepicker('maxDate', e.date);
    });

    const form = $("#CreateMessageForm");
    const editorInputs = $(".html-editor");
    attachSummernote(editorInputs);

    formSubmitWithSpinner(
        form[0] as HTMLFormElement,
        $("#submit")[0]
    );
});